export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq4b-Alerts-Lockout.4a4560b0.png";